import { Box, Button, TextField } from '@mui/material';
import * as styles from './CatalogFilterBar.styles';

interface TextFilterProps {
  label: string;
  value: string;
  onChange: (value: string | undefined) => void;
}

export const TextFilter = ({ label, value, onChange }: TextFilterProps) => (
  <Box sx={styles.popoverContent}>
    <TextField
      autoFocus
      size="small"
      label={label}
      value={value}
      onChange={(e) => onChange(e.target.value || undefined)}
      sx={{ width: '100%' }}
    />
    <Button
      variant="text"
      size="small"
      disabled={value === ''}
      onClick={() => onChange(undefined)}
      sx={styles.clearButton}
    >
      Clear
    </Button>
  </Box>
);
